import { toValue, type MaybeRefOrGetter } from 'vue'
import type { AiHostCapabilities, SeekerClient } from './client'

export interface SetupAiChatOptions {
  client: SeekerClient
  userId?: MaybeRefOrGetter<string>
  host?: AiHostCapabilities
}

const holder: {
  client: SeekerClient | null
  host: AiHostCapabilities
  userId: () => string
} = {
  client: null,
  host: {},
  userId: () => 'anonymous',
}

export function setupAiChat(options: SetupAiChatOptions): void {
  holder.client = options.client
  holder.host = options.host ?? {}
  if (options.userId != null) {
    const source = options.userId
    holder.userId = () => {
      const value = toValue(source)
      return value?.trim() ? value : 'anonymous'
    }
  }
}

export function useAiClient(): SeekerClient {
  if (!holder.client) {
    throw new Error(
      '[ZAi] 请先调用 setupAiChat({ client }) 再使用 AI 组件'
    )
  }
  return holder.client
}

export function useAiHost(): AiHostCapabilities {
  return holder.host
}

export function getAiUserId(): string {
  return holder.userId()
}
